import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3844d9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calm-title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "form-input-description"
}
const _hoisted_4 = { class: "form-input-description error-description" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "form-input-description"
}
const _hoisted_7 = { class: "form-input-description error-description" }
const _hoisted_8 = { class: "form-input-description" }
const _hoisted_9 = { class: "form-input-description error-description" }
const _hoisted_10 = { class: "form-input-description" }
const _hoisted_11 = { class: "form-input-description error-description" }
const _hoisted_12 = { class: "calm-items-wrapper" }
const _hoisted_13 = { class: "calm-left-sidebar" }
const _hoisted_14 = { class: "calm-center-content" }
const _hoisted_15 = { class: "calm-center-toolbar" }
const _hoisted_16 = { class: "calm-center-toolbar-title" }
const _hoisted_17 = { class: "calm-center-toolbar-right-section" }
const _hoisted_18 = { class: "calm-center-toolbar-source-content" }
const _hoisted_19 = { class: "calm-center-toolbar-items-content" }
const _hoisted_20 = { class: "calm-breadcrumb" }
const _hoisted_21 = { class: "child-fso-header" }
const _hoisted_22 = { class: "flex-grow-1" }
const _hoisted_23 = { class: "w-60" }
const _hoisted_24 = { class: "w-150" }
const _hoisted_25 = {
  key: 0,
  class: "explorerContent"
}
const _hoisted_26 = { class: "calm-right-sidebar" }
const _hoisted_27 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_input = _resolveComponent("f-input")!
  const _component_f_form_item = _resolveComponent("f-form-item")!
  const _component_f_select_standard = _resolveComponent("f-select-standard")!
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_f_form = _resolveComponent("f-form")!
  const _component_f_tab_pane = _resolveComponent("f-tab-pane")!
  const _component_f_search_bar = _resolveComponent("f-search-bar")!
  const _component_FileSystemObject = _resolveComponent("FileSystemObject")!
  const _component_f_breadcrumb = _resolveComponent("f-breadcrumb")!
  const _component_f_checkbox = _resolveComponent("f-checkbox")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_CalmRightSideSection = _resolveComponent("CalmRightSideSection")!
  const _component_f_tabs = _resolveComponent("f-tabs")!
  const _component_f_spin = _resolveComponent("f-spin")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_modal = _resolveComponent("f-modal")!

  return (_openBlock(), _createBlock(_component_f_modal, {
    visible: _ctx.isVisible,
    class: "alm-calm-modal",
    onOk: _ctx.confirm,
    "onUpdate:visible": _cache[8] || (_cache[8] = (vis) => _ctx.setVisible(vis))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_f_button, {
          text: "Button",
          type: "default",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setVisible(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize('Cancel_PascalCase')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_f_button, {
          text: "Button",
          type: "ghost",
          onClick: _ctx.save,
          class: "ml3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize('Save_CamelCase')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives(_createVNode(_component_f_button, {
          text: "Button",
          type: "primary",
          onClick: _ctx.goToSecondTab,
          class: "ml3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize('DimensionMemberSelector_Move_To_Next')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.activeTabKey === 1]
        ]),
        _withDirectives(_createVNode(_component_f_button, {
          text: "Button",
          type: "primary",
          onClick: _ctx.saveAndClose,
          class: "ml3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize('DimensionMemberSelector_Move_To_Next')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.activeTabKey === 2]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_f_spin, { spinning: _ctx.spinning }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              id: "logo",
              src: _ctx.appLogo,
              height: "32",
              width: "32"
            }, null, 8, _hoisted_2),
            _createElementVNode("h3", null, _toDisplayString(_ctx.isEditView? `${_ctx.localizer.Localize('Edit')} ${_ctx.currentChangeset?.name}` : _ctx.localizer.Localize('LandscapeManagementManage_NewChangeSet')), 1)
          ]),
          _createVNode(_component_f_tabs, {
            class: "alm-calm-tabs",
            icons: true,
            activeKey: _ctx.activeTabKey
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_f_tab_pane, {
                class: "alm-forms-tab",
                icon: "member",
                key: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_f_form, {
                    class: "calm-form",
                    onSubmit: _ctx.checkForm
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_f_form_item, {
                        label: _ctx.localizer.Localize('Name'),
                        class: _normalizeClass({ 'has-error': _ctx.submitted && _ctx.calmModelErrors.name.length }),
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f_input, {
                            value: _ctx.calmModel.name,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calmModel.name) = $event)),
                            onKeyup: _ctx.checkNameSpecialCharacters,
                            disabled: _ctx.isEditView,
                            placeholder: _ctx.localizer.Localize('LandscapeManagementManage_EnterAChangeSetName')
                          }, null, 8, ["value", "onKeyup", "disabled", "placeholder"]),
                          _createElementVNode("div", null, [
                            (_ctx.localizer.Localize('LandscapeManagementManage_DescribeWhatKind'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.localizer.Localize('LandscapeManagementManage_DescribeWhatKind')), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calmModelErrors.name, (errorText) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorText), 1))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }, 8, ["label", "class"]),
                      _createVNode(_component_f_form_item, {
                        label: _ctx.localizer.Localize('LandscapeManagementManage_Description_Field'),
                        class: _normalizeClass({ 'has-error': _ctx.submitted && _ctx.calmModelErrors.description.length })
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("textarea", {
                            class: "f-textarea",
                            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkDescriptionInput && _ctx.checkDescriptionInput(...args))),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calmModel.description) = $event)),
                            type: "textarea",
                            placeholder: _ctx.localizer.Localize('LandscapeManagementManage_DescribeYourChange')
                          }, null, 40, _hoisted_5), [
                            [
                              _vModelText,
                              _ctx.calmModel.description,
                              void 0,
                              { value: true }
                            ]
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.localizer.Localize('LandscapeManagementManage_DescribeWhatKind'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.localizer.Localize('LandscapeManagementManage_DescribeWhatKind')), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calmModelErrors.description, (errorText) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorText), 1))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }, 8, ["label", "class"]),
                      _createVNode(_component_f_form_item, {
                        label: _ctx.localizer.Localize('LandscapeManagementManage_Source'),
                        required: "",
                        class: _normalizeClass({ 'has-error': _ctx.submitted && _ctx.calmModelErrors.source.length })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_f_select_standard, {
                            options: _ctx.sourceTenantsOption,
                            onChange: _ctx.checkSourceSelect,
                            value: _ctx.calmModel.source,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calmModel.source) = $event)),
                            disabled: _ctx.isEditView,
                            placeholder: _ctx.localizer.Localize('Select')
                          }, null, 8, ["options", "onChange", "value", "disabled", "placeholder"]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.localizer.Localize('LandscapeManagementManage_YouMustSelectSource')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calmModelErrors.source, (errorText) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorText), 1))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }, 8, ["label", "class"]),
                      _createVNode(_component_f_form_item, {
                        label: _ctx.localizer.Localize('LandscapeManagementManage_Target'),
                        required: "",
                        disabled: !_ctx.calmModel.source,
                        class: _normalizeClass({ 'has-error': _ctx.submitted && _ctx.calmModelErrors.target.length })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MultiSelectDropdown, {
                            modelValue: _ctx.selectedItems,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems) = $event)),
                            options: _ctx.targetTenantsOption,
                            disabled: !_ctx.calmModel.source
                          }, null, 8, ["modelValue", "options", "disabled"]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.localizer.Localize('LandscapeManagementManage_YouMustSelectTarget')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calmModelErrors.target, (errorText) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorText), 1))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }, 8, ["label", "disabled", "class"])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_f_tab_pane, {
                icon: "member",
                key: 2
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_f_search_bar, {
                        value: _ctx.search,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                        activeIndex: _ctx.activeIndex,
                        count: _ctx.searchCount,
                        onNext: _ctx.moveToNext,
                        onPrev: _ctx.moveToPrevious,
                        class: "calm-search",
                        placeholder: "Search"
                      }, null, 8, ["value", "activeIndex", "count", "onNext", "onPrev"]),
                      (_ctx.root)
                        ? (_openBlock(), _createBlock(_component_FileSystemObject, {
                            key: 0,
                            isAlm: true,
                            class: "mt1",
                            Fso: _ctx.root,
                            ChangeUrlOnSelect: false,
                            CanUserExpand: true,
                            CanUserSelect: true,
                            HighlightSearchResults: true,
                            CanUserOpenWithDoubleClick: true
                          }, null, 8, ["Fso"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.calmModel?.name), 1),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("h4", null, _toDisplayString(`${_ctx.localizer.Localize('LandscapeManagement_Source')}:`), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.getTenantNameById(_ctx.calmModel?.source)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.selectedFsoChildren?.length), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Items_Text')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_f_breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_f_checkbox, {
                            text: "Checkbox",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleFsoChild($event?.target?.checked, _ctx.selectedFso))),
                            indeterminate: _ctx.selectedFso.almIntermediateChecked,
                            checked: _ctx.selectedFso.almChecked
                          }, null, 8, ["indeterminate", "checked"])
                        ]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.localizer.Localize('Explorer_Name')), 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.localizer.Localize('Explorer_Type')), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.localizer.Localize('Explorer_Date_Modified')), 1)
                      ], 512), [
                        [_vShow, _ctx.selectedFsoChildren.length]
                      ]),
                      (!_ctx.selectedFsoChildren || _ctx.selectedFsoChildren.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_Empty, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localizer.Localize("EditOfficeReportPanel_Nothing_Selected")), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFsoChildren, (child, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: child.id,
                          class: "fso-wrapper"
                        }, [
                          _createVNode(_component_f_checkbox, {
                            checked: child.almChecked,
                            indeterminate: child.almIntermediateChecked,
                            onChange: ($event: any) => (_ctx.toggleFsoChild($event?.target?.checked, child))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FileSystemObject, {
                                Fso: child,
                                CanUserExpand: false,
                                isAlm: true,
                                CanUserSelect: false,
                                ChangeUrlOnSelect: false,
                                HideExpander: true,
                                HighlightSearchResults: true,
                                CanUserOpenWithDoubleClick: false,
                                Secondary: true
                              }, null, 8, ["Fso"])
                            ]),
                            _: 2
                          }, 1032, ["checked", "indeterminate", "onChange"])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_CalmRightSideSection, { onToggleFsoChild: _ctx.toggleFsoChild }, null, 8, ["onToggleFsoChild"])
                    ])
                  ])
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["activeKey"])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "onOk"]))
}